import { trackEvent } from "@utils/api/tracker";

export const onStartTelehealthFeedbackSurvey = async () => {
  trackEvent("StartedTelehealthFeedback");
};
